import React from 'react';
import { useNavigate } from 'react-router-dom';

import Projects from '../../api/project'

const ProjectSectionS3 = () => {
    const navigate = useNavigate();

    const handleProjectClick = (projectId) => {
        navigate(`/project-single/${projectId}`);
    };




    return (
        <div className="wpo-project-area-s3">
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="wpo-project-wrap">
                        <div className="sortable-gallery">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="project-grids gallery-container clearfix">
                                        {Projects.slice(9, 14).map((project, pot) => (
                                            <div className="grid" key={pot}>
                                                <div className="wpo-project-item" onClick={() => handleProjectClick(project.Id)} style={{ cursor: 'pointer' }}>
                                                    <div className="wpo-project-img">
                                                        <img src={project.pImg} alt="" />
                                                        <div className="left-border"></div>
                                                        <div className="right-border"></div>
                                                    </div>
                                                    <div className="wpo-project-text">
                                                        <h2>{project.title}</h2>
                                                        <span>{project.subTitle}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>  
    );
}

export default ProjectSectionS3;

